module.exports = __webpack_public_path__ + "static/media/nexus.1bd1e854.png";